import { render, staticRenderFns } from "./pelanggaran.vue?vue&type=template&id=b077ea1a"
import script from "./pelanggaran.vue?vue&type=script&lang=js"
export * from "./pelanggaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports